import { JetAircraftOverviewConfig } from '@/types/jetDetails.types';
import styles from './jetDetails.module.scss';
import Image from 'next/image';

const JetAircraftOverview = ({
  citationConfig,
}: {
  citationConfig: JetAircraftOverviewConfig;
}) => {
  return (
    <section className="container">
      <div className={styles.jetDetails}>
        <h2 className={styles.jetDetailsTitle}>Aircraft Overview</h2>
        <div className={styles.jetDetailsContent}>
          <div className={styles.jetDetailsLineMaineTitle}>
            Passenger Capacity
          </div>
          <div className={styles.jetDetailsLineItems}>
            {citationConfig.items.PassengerCapacity.map((item) => (
              <div key={item.id} className={styles.jetDetailsLine}>
                <Image
                  src={'img/details/check-circled.svg'}
                  alt={item.title}
                  width={24}
                  height={24}
                />
                <div className={styles.jetDetailsLineTitle}>
                  {item.title}
                  <span className={styles.jetDetailsLineValue}>
                    {item.value}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.jetDetailsContent}>
          <div className={styles.jetDetailsLineMaineTitle}>Range</div>
          <div className={styles.jetDetailsLineItems}>
            {citationConfig.items.Range.map((item) =>
              item.id === 2 ? (
                <div key={item.id} className={styles.jetDetailsLine}>
                  <Image
                    src={'img/details/check-circled.svg'}
                    alt={item.title}
                    width={24}
                    height={24}
                  />
                  <div className={styles.jetDetailsLineTitle}>
                    <span className={styles.jetDetailsLineValue}>
                      {item.title} {item.value}
                    </span>
                  </div>
                </div>
              ) : (
                <div key={item.id} className={styles.jetDetailsLine}>
                  <Image
                    src={'img/details/check-circled.svg'}
                    alt={item.title}
                    width={24}
                    height={24}
                  />
                  <div className={styles.jetDetailsLineTitle}>
                    {item.title}{' '}
                    <span className={styles.jetDetailsLineValue}>
                      {item.value}
                    </span>
                  </div>
                </div>
              )
            )}
          </div>
        </div>

        <div className={styles.jetDetailsContent}>
          <div className={styles.jetDetailsLineMaineTitle}>Cruising Speed</div>
          <div className={styles.jetDetailsLineItems}>
            {citationConfig.items.CruisingSpeed.map((item) => (
              <div key={item.id} className={styles.jetDetailsLine}>
                <Image
                  src={'img/details/check-circled.svg'}
                  alt={item.title}
                  width={24}
                  height={24}
                />
                <div className={styles.jetDetailsLineTitle}>
                  {item.title}
                  <span className={styles.jetDetailsLineValue}>
                    {item.value}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.jetDetailsContent}>
          <div className={styles.jetDetailsLineMaineTitle}>
            Cabin Dimensions
          </div>
          <div className={styles.jetDetailsLineItems}>
            {citationConfig.items.CabinDimensions.map((item) => (
              <div key={item.id} className={styles.jetDetailsLine}>
                <Image
                  src={'img/details/check-circled.svg'}
                  alt={item.title}
                  width={24}
                  height={24}
                />
                <div className={styles.jetDetailsLineTitle}>
                  {item.title}
                  <span className={styles.jetDetailsLineValue}>
                    {item.value}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default JetAircraftOverview;
